import type { AuthRepository } from '@/domain/auth/AuthRepository'
import type { LoginResponse } from '@/domain/auth/LoginResponse'
import type { RegisterRequest } from '@/domain/auth/RegisterRequest'
import type { User } from '@/domain/auth/User'
import type { UserClient } from '@/domain/auth/UserClient'

export class AuthService {
  constructor(private readonly authRepository: AuthRepository) {}

  async login(email: string, pass: string): Promise<LoginResponse> {
    return this.authRepository.login(email, pass)
  }

  async register(request: RegisterRequest): Promise<User> {
    return this.authRepository.register(request)
  }

  async findAll(): Promise<User[]> {
    return this.authRepository.findAll()
  }

  async findAllUserClients(): Promise<UserClient[]> {
    return this.authRepository.findAllUserClients()
  }
}
